import { useTranslation } from "react-i18next";

interface LanguageSwitcherProps {
  isDark?: boolean;
}

export default function LanguageSwitcher({ isDark = false }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language === "en" ? "en" : "ja";

  const toggle = () => {
    const next = currentLang === "ja" ? "en" : "ja";
    i18n.changeLanguage(next);
  };

  const textColor = isDark
    ? "text-white/70 hover:text-white"
    : "text-airdoa-navy/70 hover:text-airdoa-navy";

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-1 text-xs font-medium tracking-wide transition-colors duration-200 px-2 py-1 rounded border ${
        isDark
          ? "border-white/20 text-white/70 hover:border-white/50 hover:text-white"
          : "border-airdoa-navy/20 text-airdoa-navy/60 hover:border-airdoa-navy/50 hover:text-airdoa-navy"
      }`}
      aria-label="Toggle language"
    >
      <i className="ri-translate-2 text-sm" />
      <span>{currentLang === "ja" ? "EN" : "JA"}</span>
    </button>
  );
}
